import { gql } from "@apollo/client";

export const CITIES_INFORMATION = gql`
query CityInformation($code: String!, $culture: String!) {
    city(where: {code: {code: $code}, localization: {culture: $culture}}) {
      contentItemId
      __typename
      area
      climate
      createdUtc
      displayText
      population
      forecaWeatherId
      openStreetMapId
      tourismOrder
      level
      modifiedUtc
      name
      climate
      nickname
      population
      publishedUtc
      render
      sortIndex
      forecaWeatherId
      cover {
        paths
      }
      content {
        contentItems {
          contentItemId
          contentType
        }
      }
    }
  } 
`